import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/app/startup/$id/profile/deep-insights')({
  component: () => null,
})
